import React, { useEffect, useState } from "react"
import { ActivityIndicator, StyleSheet, View } from "react-native"
import { useSelector } from "react-redux"

import Base, { Firebase, Sentry } from "../../base"
import { ReloadView } from "../common"
import OrdersScreen from "../orders/OrdersScreen"
import VenueSelectorScreen from "../venues/VenueSelectorScreen"
import LoginScreen from "./Login/LoginScreen"

export default function RootScreen(props) {
  const [configFetched, setConfigFetched] = useState(null)
  const credentials = useSelector(state => state.credentials)
  const venue = useSelector(state => state.venue)

  useEffect(() => {
    fetchConfig()
  }, [])

  async function fetchConfig() {
    setConfigFetched(null)
    Firebase.init()
      .then(() => {
        setConfigFetched(true)
      })
      .catch(_ => {
        setConfigFetched(false)
      })
    Sentry.init()
  }

  if (configFetched === null) {
    props.navigation.setOptions(Base.constants.headerOptions(true))
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={Base.colours.appGrey} />
      </View>
    )
  } else if (!configFetched) {
    return (
      <View style={styles.main}>
        <ReloadView
          title={`No internet connection found,\nplease tap below to try again.`}
          onPress={fetchConfig}
        />
      </View>
    )
  }

  if (
    credentials.idToken === null ||
    typeof credentials.idToken === "undefined"
  ) {
    return <LoginScreen navigation={props.navigation} />
  } else if (venue === null) {
    return <VenueSelectorScreen navigation={props.navigation} />
  } else {
    return <OrdersScreen navigation={props.navigation} />
  }
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    justifyContent: "space-between",
  },
  loadingContainer: { flex: 1, justifyContent: "center" },
})
